import { TicketDTO } from './ticket.dto';
import { BaseUserWithRole } from '@sb-tools/typescript/models/base-user-with-role.model';
import { NoteDTO } from './note.dto';
import { FacebookReaction } from '@sb-tools/typescript/models/facebook-reaction.model';
import { AttachmentBase } from 'src/sb-tools/typescript/models/attachment-base.model';
import { ThreadElementDTO } from '@sb-tools/typescript/models/dto/thread-element.dto';
import { SatisfactionDTO } from './satisfaction.dto';
import { EmailEnvelope } from '@sb-tools/typescript/models/email-envelope.model';
import { TagDTO } from '@sb-tools/typescript/models/dto/tag.dto';
import { TicketReminderDTO } from '@sb-tools/typescript/models/dto/ticket-reminder.dto';
import { SurveyDTO } from './survey.dto';
import { signal, WritableSignal } from '@angular/core';
import { TicketConstraints } from '../ticket-constraints.model';
import { FacebookMentionUserModel } from '../facebook-mention-user-model.model';
import { FieldDTO } from '../field-gui-model.model';
import { FilteredRepliesCount } from '../filtered-replies-count.model';
import { LocationModel } from '../location.model';
import { Suggestion } from '../suggestion.model';
import { TicketView } from '../../../core/enums/ticket-view.enum';
import { UserToMention } from '../user-to-mention.model';
import { LinkedTicketDTO } from './linked-ticket.dto';
import { EmailRecipientsDTO } from './email-recipients.dto';

export class DetailedTicketDTO extends TicketDTO {
    attachments: AttachmentBase[];
    authorTicketCount: number;
    bccEmails: string[]; // deprecated
    ccEmails: string[]; // deprecated
    contentAttachments: AttachmentBase[] = []; // GUI only
    communityName: string;
    constraints: TicketConstraints;
    defaultReplyRecipients: EmailRecipientsDTO;
    defaultSocialMediaSourceId: number;
    emailInfo: EmailEnvelope;
    facebookUsersToMention: FacebookMentionUserModel[];
    fields: FieldDTO[] = [];
    filteredRepliesCount: FilteredRepliesCount;
    firstMessageCreatorIpAddress: string;
    hasContentPartHiddenForClient: boolean;
    hasReactionFromTeam: boolean;
    initialPageUrl: string;
    isAutoHidden: boolean;
    isContentHiddenForClient: boolean;
    isEditable: boolean;
    isLiked: boolean;
    isReplyCanBeEdited: boolean; // only gui property
    isTicketCanBeReplied: boolean; // only gui property
    isTechnicalChatInitiationMessage: boolean;
    latestPageUrl: string;
    likeCount: number;
    linkedTicketCount: number;
    location: LocationModel;
    mentionedUsers: string[];
    messageThread: (ThreadElementDTO | SatisfactionDTO | SurveyDTO)[];
    newAttachments?: AttachmentBase[]; // gui only
    notContentAttachments: AttachmentBase[] = []; // GUI only
    notes: NoteDTO[];
    outboundEmailAddress?: string;
    parent: LinkedTicketDTO;
    phoneNumber: string;
    reactions: FacebookReaction[];
    reminder: TicketReminderDTO;
    resentFromEmailAddress: string;
    selectedRepliesCount: WritableSignal<number> = signal(0); // gui only
    sharedLink: string;
    socialMediaSourceAccountName: string;
    socialMediaSourceId?: string;
    starRating: number;
    suggestions: Suggestion[];
    tags: TagDTO[];
    teammatesWithAccess: BaseUserWithRole[];
    ticketViewType: TicketView; // only gui property
    toEmails: string[]; // deprecated
    unreadNoteCount: number;
    usersToMention: UserToMention[];
    vendorsWithAccess: BaseUserWithRole[];
    videoLink: string;
    videoPreview: string;
}
